import '@core/scss/vue/libs/vue-sweetalert.scss';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)
